/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Update_SuccessInputs */

const en_admin_payments_update_success = /** @type {(inputs: Admin_Payments_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order updated`)
};

const zh_admin_payments_update_success = /** @type {(inputs: Admin_Payments_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单已更新`)
};

/**
* | output |
* | --- |
* | "Order updated" |
*
* @param {Admin_Payments_Update_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_update_success = /** @type {((inputs?: Admin_Payments_Update_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Update_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_update_success(inputs)
	return zh_admin_payments_update_success(inputs)
});
export { admin_payments_update_success as "admin.payments.update_success" }